//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShareQuestion from './ShareQuestion.vue'
import SubmitTip from './SubmitTip.vue'
import SubmitCopy from './SubmitCopy.vue'
import SubmitDelete from './SubmitDelete.vue'
import { request } from '@/tools/index.js'
export default {
  data() {
    return {
      color: { 10: 'nostart', 20: 'completed', 30: 'completed', 40: 'hurry' },
      completedList: ['20', '30'],
      actionList: [
        { name: '编辑', icon: 'icon-edit', handler: this.edit },
        { name: '分享', icon: 'icon-share', handler: this.share },
        {
          name: '数据',
          icon: 'icon-data',
          isDisabled: true,
          handler: this.viewData,
        },
        { name: '更多', icon: 'icon-more', handler: this.viewMore },
      ],
    }
  },
  props: {
    item: {
      type: Object,
    },
    status: {
      type: Number,
    },
  },
  filters: {
    status(val) {
      let status = { 10: '未发布', 20: '已发布', 30: '已发布', 40: '暂停发布' }
      return status[val]
    },
  },
  computed: {},
  methods: {
    // 编辑
    edit() {
      if (this.completedList.includes(this.item.status)) {
        this.editTip()
      } else {
        this.editView()
      }
    },
    // 发布提示
    editTip() {
      let _this = this
      new this.$Popup(SubmitTip, {
        position: 'bottom',
        isMaskClose: false,
        title:'该问卷已发布，是否继续编辑？',
        size: '120px',
        item: this.item,
        onrelease() {
          _this.updateStatus(() => {
            _this.editView()
          })
        },
      })
    },
    //更改状态
    updateStatus(callback) {
      const loading = new this.$Loading()
      let question = {
        userCode: this.user.ldap,
        questionnaireId: this.item.tenantId,
      }
      return request('updateQuestionnaireStatus', question)
        .then((res) => {
          typeof callback == 'function' ? callback() : ''
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    // 跳转到编辑
    editView() {
      this.$router.push({
        name: 'createItem',
        query: {
          questionnaireId: this.item.tenantId,
        },
      })
    },
    // 发布问题
    releaseQuestion(callback) {
      const loading = new this.$Loading()
      let question = {
        userCode: this.user.ldap,
        questionnaireId: this.item.tenantId,
      }
      return request('releaseQuestion', question)
        .then((res) => {
          typeof callback == 'function' ? callback() : ''
          this.$emit('refresh')
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    // 数据
    viewData() {},
    // 分享
    share() {
      if (this.completedList.includes(this.item.status)) {
        new this.$Popup(ShareQuestion, {
          position: 'bottom',
          isMaskClose: false,
          size: '140px',
          item: this.item,
        })
      } else {
        let _this = this
        new this.$Popup(SubmitTip, {
          position: 'bottom',
          isMaskClose: false,
          size: '120px',
          item: this.item,
          onrelease() {
            _this.releaseQuestion()
          },
        })
      }
    },
    // 更多
    viewMore() {
      new this.$ActionSheet({
        data: [
          {
            text: '预览',
            value: 1,
            handler: this.review,
          },
          {
            text: '设置',
            value: 2,
            handler: this.setting,
          },
          {
            text: '复制',
            value: 3,
            handler: this.copy,
          },
          {
            text: '删除',
            value: 4,
            handler: this.delete,
          },
        ],
        onChange: (item) => {
          item.handler()
        },
      })
    },
    // 预览
    review() {
      this.$router.push({
        name: 'detail',
        query: {
          questionnaireId: this.item.tenantId,
          isQuestion: 1,
          currentListStatus: 10, // 当前列表状态
        },
      })
    },
    // 设置
    setting() {
      this.$router.push({
        name: 'settings',
        query: {
          questionnaireId: this.item.tenantId,
        },
      })
    },
    // 复制
    copy() {
      let _this = this
      new this.$Popup(SubmitCopy, {
        position: 'bottom',
        isMaskClose: false,
        size: '150px',
        item: this.item,
        onsubmit(emitObj) {
          _this.$emit('copy', emitObj)
        },
      })
    },
    // 删除
    delete() {
      let _this = this
      new this.$Popup(SubmitDelete, {
        position: 'bottom',
        isMaskClose: false,
        size: '120px',
        item: this.item,
        onsubmit(emitObj) {
          _this.$emit('delete', emitObj)
        },
      })
    },
  },
}
